export let TITLE_POSITION_VALUES = /*#__PURE__*/function (TITLE_POSITION_VALUES) {
  TITLE_POSITION_VALUES[TITLE_POSITION_VALUES["CENTER"] = 1] = "CENTER";
  TITLE_POSITION_VALUES[TITLE_POSITION_VALUES["BOTTOM"] = 2] = "BOTTOM";
  return TITLE_POSITION_VALUES;
}({});
//# sourceMappingURL=title-position-values.js.map